exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header .close {\r\n\tdisplay: none;\r\n}\r\n\r\nlabel {\r\n\tfont-size: 10pt;\r\n\tfont-weight: normal;\r\n\tcolor: #444;\r\n}\r\n\r\ntextarea {\r\n\tresize: none;\r\n\tmin-height: 120px;\r\n\twidth: 100%;\r\n}\r\n\r\n.ui-inputtext {\r\n\twidth: 100%;\r\n\tbackground: #ffffff;\r\n    color: #222222;\r\n    transition: .2s;\r\n} \r\n\r\ninput[name='taskTitle'] {\r\n\tfont-size: 13pt;\r\n\tbackground-color: #ffffcc;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/task-detail/task-detail.component.css
// module id = 358
// module chunks = 0